/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as VeterinaryRouteImport } from './routes/veterinary'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as SentinelRouteImport } from './routes/sentinel'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as MosquitoRouteImport } from './routes/mosquito'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SentinelPackingslipsRouteImport } from './routes/sentinel/packingslips'
import { Route as AdminUsersRouteImport } from './routes/admin/users'

const VeterinaryIndexLazyRouteImport = createFileRoute('/veterinary/')()
const SentinelIndexLazyRouteImport = createFileRoute('/sentinel/')()
const MosquitoIndexLazyRouteImport = createFileRoute('/mosquito/')()
const AdminIndexLazyRouteImport = createFileRoute('/admin/')()
const VeterinaryAddLazyRouteImport = createFileRoute('/veterinary/add')()
const VeterinaryIdLazyRouteImport = createFileRoute('/veterinary/$id')()
const SentinelAddLazyRouteImport = createFileRoute('/sentinel/add')()
const SentinelIdLazyRouteImport = createFileRoute('/sentinel/$id')()
const MosquitoAddLazyRouteImport = createFileRoute('/mosquito/add')()
const MosquitoIdLazyRouteImport = createFileRoute('/mosquito/$id')()
const SentinelPackingslipsIndexLazyRouteImport = createFileRoute(
  '/sentinel/packingslips/',
)()
const AdminUsersIndexLazyRouteImport = createFileRoute('/admin/users/')()
const SentinelPackingslipsAddLazyRouteImport = createFileRoute(
  '/sentinel/packingslips/add',
)()
const SentinelPackingslipsIdLazyRouteImport = createFileRoute(
  '/sentinel/packingslips/$id',
)()
const AdminUsersAddLazyRouteImport = createFileRoute('/admin/users/add')()
const AdminUsersIdLazyRouteImport = createFileRoute('/admin/users/$id')()

const VeterinaryRoute = VeterinaryRouteImport.update({
  id: '/veterinary',
  path: '/veterinary',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const SentinelRoute = SentinelRouteImport.update({
  id: '/sentinel',
  path: '/sentinel',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const MosquitoRoute = MosquitoRouteImport.update({
  id: '/mosquito',
  path: '/mosquito',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VeterinaryIndexLazyRoute = VeterinaryIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VeterinaryRoute,
} as any).lazy(() =>
  import('./routes/veterinary/index.lazy').then((d) => d.Route),
)
const SentinelIndexLazyRoute = SentinelIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SentinelRoute,
} as any).lazy(() =>
  import('./routes/sentinel/index.lazy').then((d) => d.Route),
)
const MosquitoIndexLazyRoute = MosquitoIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MosquitoRoute,
} as any).lazy(() =>
  import('./routes/mosquito/index.lazy').then((d) => d.Route),
)
const AdminIndexLazyRoute = AdminIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any).lazy(() => import('./routes/admin/index.lazy').then((d) => d.Route))
const VeterinaryAddLazyRoute = VeterinaryAddLazyRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => VeterinaryRoute,
} as any).lazy(() =>
  import('./routes/veterinary/add.lazy').then((d) => d.Route),
)
const VeterinaryIdLazyRoute = VeterinaryIdLazyRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => VeterinaryRoute,
} as any).lazy(() =>
  import('./routes/veterinary/$id.lazy').then((d) => d.Route),
)
const SentinelAddLazyRoute = SentinelAddLazyRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => SentinelRoute,
} as any).lazy(() => import('./routes/sentinel/add.lazy').then((d) => d.Route))
const SentinelIdLazyRoute = SentinelIdLazyRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SentinelRoute,
} as any).lazy(() => import('./routes/sentinel/$id.lazy').then((d) => d.Route))
const MosquitoAddLazyRoute = MosquitoAddLazyRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => MosquitoRoute,
} as any).lazy(() => import('./routes/mosquito/add.lazy').then((d) => d.Route))
const MosquitoIdLazyRoute = MosquitoIdLazyRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => MosquitoRoute,
} as any).lazy(() => import('./routes/mosquito/$id.lazy').then((d) => d.Route))
const SentinelPackingslipsRoute = SentinelPackingslipsRouteImport.update({
  id: '/packingslips',
  path: '/packingslips',
  getParentRoute: () => SentinelRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const SentinelPackingslipsIndexLazyRoute =
  SentinelPackingslipsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SentinelPackingslipsRoute,
  } as any).lazy(() =>
    import('./routes/sentinel/packingslips/index.lazy').then((d) => d.Route),
  )
const AdminUsersIndexLazyRoute = AdminUsersIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminUsersRoute,
} as any).lazy(() =>
  import('./routes/admin/users/index.lazy').then((d) => d.Route),
)
const SentinelPackingslipsAddLazyRoute =
  SentinelPackingslipsAddLazyRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => SentinelPackingslipsRoute,
  } as any).lazy(() =>
    import('./routes/sentinel/packingslips/add.lazy').then((d) => d.Route),
  )
const SentinelPackingslipsIdLazyRoute =
  SentinelPackingslipsIdLazyRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => SentinelPackingslipsRoute,
  } as any).lazy(() =>
    import('./routes/sentinel/packingslips/$id.lazy').then((d) => d.Route),
  )
const AdminUsersAddLazyRoute = AdminUsersAddLazyRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AdminUsersRoute,
} as any).lazy(() =>
  import('./routes/admin/users/add.lazy').then((d) => d.Route),
)
const AdminUsersIdLazyRoute = AdminUsersIdLazyRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminUsersRoute,
} as any).lazy(() =>
  import('./routes/admin/users/$id.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/error': typeof ErrorRoute
  '/mosquito': typeof MosquitoRouteWithChildren
  '/profile': typeof ProfileRoute
  '/sentinel': typeof SentinelRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/veterinary': typeof VeterinaryRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/sentinel/packingslips': typeof SentinelPackingslipsRouteWithChildren
  '/mosquito/$id': typeof MosquitoIdLazyRoute
  '/mosquito/add': typeof MosquitoAddLazyRoute
  '/sentinel/$id': typeof SentinelIdLazyRoute
  '/sentinel/add': typeof SentinelAddLazyRoute
  '/veterinary/$id': typeof VeterinaryIdLazyRoute
  '/veterinary/add': typeof VeterinaryAddLazyRoute
  '/admin/': typeof AdminIndexLazyRoute
  '/mosquito/': typeof MosquitoIndexLazyRoute
  '/sentinel/': typeof SentinelIndexLazyRoute
  '/veterinary/': typeof VeterinaryIndexLazyRoute
  '/admin/users/$id': typeof AdminUsersIdLazyRoute
  '/admin/users/add': typeof AdminUsersAddLazyRoute
  '/sentinel/packingslips/$id': typeof SentinelPackingslipsIdLazyRoute
  '/sentinel/packingslips/add': typeof SentinelPackingslipsAddLazyRoute
  '/admin/users/': typeof AdminUsersIndexLazyRoute
  '/sentinel/packingslips/': typeof SentinelPackingslipsIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/profile': typeof ProfileRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/mosquito/$id': typeof MosquitoIdLazyRoute
  '/mosquito/add': typeof MosquitoAddLazyRoute
  '/sentinel/$id': typeof SentinelIdLazyRoute
  '/sentinel/add': typeof SentinelAddLazyRoute
  '/veterinary/$id': typeof VeterinaryIdLazyRoute
  '/veterinary/add': typeof VeterinaryAddLazyRoute
  '/admin': typeof AdminIndexLazyRoute
  '/mosquito': typeof MosquitoIndexLazyRoute
  '/sentinel': typeof SentinelIndexLazyRoute
  '/veterinary': typeof VeterinaryIndexLazyRoute
  '/admin/users/$id': typeof AdminUsersIdLazyRoute
  '/admin/users/add': typeof AdminUsersAddLazyRoute
  '/sentinel/packingslips/$id': typeof SentinelPackingslipsIdLazyRoute
  '/sentinel/packingslips/add': typeof SentinelPackingslipsAddLazyRoute
  '/admin/users': typeof AdminUsersIndexLazyRoute
  '/sentinel/packingslips': typeof SentinelPackingslipsIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/error': typeof ErrorRoute
  '/mosquito': typeof MosquitoRouteWithChildren
  '/profile': typeof ProfileRoute
  '/sentinel': typeof SentinelRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/veterinary': typeof VeterinaryRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/sentinel/packingslips': typeof SentinelPackingslipsRouteWithChildren
  '/mosquito/$id': typeof MosquitoIdLazyRoute
  '/mosquito/add': typeof MosquitoAddLazyRoute
  '/sentinel/$id': typeof SentinelIdLazyRoute
  '/sentinel/add': typeof SentinelAddLazyRoute
  '/veterinary/$id': typeof VeterinaryIdLazyRoute
  '/veterinary/add': typeof VeterinaryAddLazyRoute
  '/admin/': typeof AdminIndexLazyRoute
  '/mosquito/': typeof MosquitoIndexLazyRoute
  '/sentinel/': typeof SentinelIndexLazyRoute
  '/veterinary/': typeof VeterinaryIndexLazyRoute
  '/admin/users/$id': typeof AdminUsersIdLazyRoute
  '/admin/users/add': typeof AdminUsersAddLazyRoute
  '/sentinel/packingslips/$id': typeof SentinelPackingslipsIdLazyRoute
  '/sentinel/packingslips/add': typeof SentinelPackingslipsAddLazyRoute
  '/admin/users/': typeof AdminUsersIndexLazyRoute
  '/sentinel/packingslips/': typeof SentinelPackingslipsIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/error'
    | '/mosquito'
    | '/profile'
    | '/sentinel'
    | '/unauthorized'
    | '/veterinary'
    | '/admin/users'
    | '/sentinel/packingslips'
    | '/mosquito/$id'
    | '/mosquito/add'
    | '/sentinel/$id'
    | '/sentinel/add'
    | '/veterinary/$id'
    | '/veterinary/add'
    | '/admin/'
    | '/mosquito/'
    | '/sentinel/'
    | '/veterinary/'
    | '/admin/users/$id'
    | '/admin/users/add'
    | '/sentinel/packingslips/$id'
    | '/sentinel/packingslips/add'
    | '/admin/users/'
    | '/sentinel/packingslips/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/profile'
    | '/unauthorized'
    | '/mosquito/$id'
    | '/mosquito/add'
    | '/sentinel/$id'
    | '/sentinel/add'
    | '/veterinary/$id'
    | '/veterinary/add'
    | '/admin'
    | '/mosquito'
    | '/sentinel'
    | '/veterinary'
    | '/admin/users/$id'
    | '/admin/users/add'
    | '/sentinel/packingslips/$id'
    | '/sentinel/packingslips/add'
    | '/admin/users'
    | '/sentinel/packingslips'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/error'
    | '/mosquito'
    | '/profile'
    | '/sentinel'
    | '/unauthorized'
    | '/veterinary'
    | '/admin/users'
    | '/sentinel/packingslips'
    | '/mosquito/$id'
    | '/mosquito/add'
    | '/sentinel/$id'
    | '/sentinel/add'
    | '/veterinary/$id'
    | '/veterinary/add'
    | '/admin/'
    | '/mosquito/'
    | '/sentinel/'
    | '/veterinary/'
    | '/admin/users/$id'
    | '/admin/users/add'
    | '/sentinel/packingslips/$id'
    | '/sentinel/packingslips/add'
    | '/admin/users/'
    | '/sentinel/packingslips/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  MosquitoRoute: typeof MosquitoRouteWithChildren
  ProfileRoute: typeof ProfileRoute
  SentinelRoute: typeof SentinelRouteWithChildren
  UnauthorizedRoute: typeof UnauthorizedRoute
  VeterinaryRoute: typeof VeterinaryRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/veterinary': {
      id: '/veterinary'
      path: '/veterinary'
      fullPath: '/veterinary'
      preLoaderRoute: typeof VeterinaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sentinel': {
      id: '/sentinel'
      path: '/sentinel'
      fullPath: '/sentinel'
      preLoaderRoute: typeof SentinelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mosquito': {
      id: '/mosquito'
      path: '/mosquito'
      fullPath: '/mosquito'
      preLoaderRoute: typeof MosquitoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/veterinary/': {
      id: '/veterinary/'
      path: '/'
      fullPath: '/veterinary/'
      preLoaderRoute: typeof VeterinaryIndexLazyRouteImport
      parentRoute: typeof VeterinaryRoute
    }
    '/sentinel/': {
      id: '/sentinel/'
      path: '/'
      fullPath: '/sentinel/'
      preLoaderRoute: typeof SentinelIndexLazyRouteImport
      parentRoute: typeof SentinelRoute
    }
    '/mosquito/': {
      id: '/mosquito/'
      path: '/'
      fullPath: '/mosquito/'
      preLoaderRoute: typeof MosquitoIndexLazyRouteImport
      parentRoute: typeof MosquitoRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexLazyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/veterinary/add': {
      id: '/veterinary/add'
      path: '/add'
      fullPath: '/veterinary/add'
      preLoaderRoute: typeof VeterinaryAddLazyRouteImport
      parentRoute: typeof VeterinaryRoute
    }
    '/veterinary/$id': {
      id: '/veterinary/$id'
      path: '/$id'
      fullPath: '/veterinary/$id'
      preLoaderRoute: typeof VeterinaryIdLazyRouteImport
      parentRoute: typeof VeterinaryRoute
    }
    '/sentinel/add': {
      id: '/sentinel/add'
      path: '/add'
      fullPath: '/sentinel/add'
      preLoaderRoute: typeof SentinelAddLazyRouteImport
      parentRoute: typeof SentinelRoute
    }
    '/sentinel/$id': {
      id: '/sentinel/$id'
      path: '/$id'
      fullPath: '/sentinel/$id'
      preLoaderRoute: typeof SentinelIdLazyRouteImport
      parentRoute: typeof SentinelRoute
    }
    '/mosquito/add': {
      id: '/mosquito/add'
      path: '/add'
      fullPath: '/mosquito/add'
      preLoaderRoute: typeof MosquitoAddLazyRouteImport
      parentRoute: typeof MosquitoRoute
    }
    '/mosquito/$id': {
      id: '/mosquito/$id'
      path: '/$id'
      fullPath: '/mosquito/$id'
      preLoaderRoute: typeof MosquitoIdLazyRouteImport
      parentRoute: typeof MosquitoRoute
    }
    '/sentinel/packingslips': {
      id: '/sentinel/packingslips'
      path: '/packingslips'
      fullPath: '/sentinel/packingslips'
      preLoaderRoute: typeof SentinelPackingslipsRouteImport
      parentRoute: typeof SentinelRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/sentinel/packingslips/': {
      id: '/sentinel/packingslips/'
      path: '/'
      fullPath: '/sentinel/packingslips/'
      preLoaderRoute: typeof SentinelPackingslipsIndexLazyRouteImport
      parentRoute: typeof SentinelPackingslipsRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexLazyRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/sentinel/packingslips/add': {
      id: '/sentinel/packingslips/add'
      path: '/add'
      fullPath: '/sentinel/packingslips/add'
      preLoaderRoute: typeof SentinelPackingslipsAddLazyRouteImport
      parentRoute: typeof SentinelPackingslipsRoute
    }
    '/sentinel/packingslips/$id': {
      id: '/sentinel/packingslips/$id'
      path: '/$id'
      fullPath: '/sentinel/packingslips/$id'
      preLoaderRoute: typeof SentinelPackingslipsIdLazyRouteImport
      parentRoute: typeof SentinelPackingslipsRoute
    }
    '/admin/users/add': {
      id: '/admin/users/add'
      path: '/add'
      fullPath: '/admin/users/add'
      preLoaderRoute: typeof AdminUsersAddLazyRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/admin/users/$id': {
      id: '/admin/users/$id'
      path: '/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AdminUsersIdLazyRouteImport
      parentRoute: typeof AdminUsersRoute
    }
  }
}

interface AdminUsersRouteChildren {
  AdminUsersIdLazyRoute: typeof AdminUsersIdLazyRoute
  AdminUsersAddLazyRoute: typeof AdminUsersAddLazyRoute
  AdminUsersIndexLazyRoute: typeof AdminUsersIndexLazyRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersIdLazyRoute: AdminUsersIdLazyRoute,
  AdminUsersAddLazyRoute: AdminUsersAddLazyRoute,
  AdminUsersIndexLazyRoute: AdminUsersIndexLazyRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminRouteChildren {
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminIndexLazyRoute: typeof AdminIndexLazyRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminIndexLazyRoute: AdminIndexLazyRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface MosquitoRouteChildren {
  MosquitoIdLazyRoute: typeof MosquitoIdLazyRoute
  MosquitoAddLazyRoute: typeof MosquitoAddLazyRoute
  MosquitoIndexLazyRoute: typeof MosquitoIndexLazyRoute
}

const MosquitoRouteChildren: MosquitoRouteChildren = {
  MosquitoIdLazyRoute: MosquitoIdLazyRoute,
  MosquitoAddLazyRoute: MosquitoAddLazyRoute,
  MosquitoIndexLazyRoute: MosquitoIndexLazyRoute,
}

const MosquitoRouteWithChildren = MosquitoRoute._addFileChildren(
  MosquitoRouteChildren,
)

interface SentinelPackingslipsRouteChildren {
  SentinelPackingslipsIdLazyRoute: typeof SentinelPackingslipsIdLazyRoute
  SentinelPackingslipsAddLazyRoute: typeof SentinelPackingslipsAddLazyRoute
  SentinelPackingslipsIndexLazyRoute: typeof SentinelPackingslipsIndexLazyRoute
}

const SentinelPackingslipsRouteChildren: SentinelPackingslipsRouteChildren = {
  SentinelPackingslipsIdLazyRoute: SentinelPackingslipsIdLazyRoute,
  SentinelPackingslipsAddLazyRoute: SentinelPackingslipsAddLazyRoute,
  SentinelPackingslipsIndexLazyRoute: SentinelPackingslipsIndexLazyRoute,
}

const SentinelPackingslipsRouteWithChildren =
  SentinelPackingslipsRoute._addFileChildren(SentinelPackingslipsRouteChildren)

interface SentinelRouteChildren {
  SentinelPackingslipsRoute: typeof SentinelPackingslipsRouteWithChildren
  SentinelIdLazyRoute: typeof SentinelIdLazyRoute
  SentinelAddLazyRoute: typeof SentinelAddLazyRoute
  SentinelIndexLazyRoute: typeof SentinelIndexLazyRoute
}

const SentinelRouteChildren: SentinelRouteChildren = {
  SentinelPackingslipsRoute: SentinelPackingslipsRouteWithChildren,
  SentinelIdLazyRoute: SentinelIdLazyRoute,
  SentinelAddLazyRoute: SentinelAddLazyRoute,
  SentinelIndexLazyRoute: SentinelIndexLazyRoute,
}

const SentinelRouteWithChildren = SentinelRoute._addFileChildren(
  SentinelRouteChildren,
)

interface VeterinaryRouteChildren {
  VeterinaryIdLazyRoute: typeof VeterinaryIdLazyRoute
  VeterinaryAddLazyRoute: typeof VeterinaryAddLazyRoute
  VeterinaryIndexLazyRoute: typeof VeterinaryIndexLazyRoute
}

const VeterinaryRouteChildren: VeterinaryRouteChildren = {
  VeterinaryIdLazyRoute: VeterinaryIdLazyRoute,
  VeterinaryAddLazyRoute: VeterinaryAddLazyRoute,
  VeterinaryIndexLazyRoute: VeterinaryIndexLazyRoute,
}

const VeterinaryRouteWithChildren = VeterinaryRoute._addFileChildren(
  VeterinaryRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ErrorRoute: ErrorRoute,
  MosquitoRoute: MosquitoRouteWithChildren,
  ProfileRoute: ProfileRoute,
  SentinelRoute: SentinelRouteWithChildren,
  UnauthorizedRoute: UnauthorizedRoute,
  VeterinaryRoute: VeterinaryRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
